/**
 * Maps the UPC raw data to a more usable format
 * @param {import('@composables/useUpc/types').UpcRaw.UpcRaw} options
 * @returns {import('@composables/useUpc/types').UseUpc.Upc}
 */
export const upcMapper = ({
  id,
  identifier: { upcNumber: number },
  availability: {
    available,
    bopsAvailability,
    bossAvailability,
    message = '',
    availabilityMessage = '',
    lowAvailability,
    orderType = '',
    holidayMessages: availabilityHolidayMessages,
    shipDays,
    shipFees,
    storeAvailability,
  },
  seller,
  marketplaceFlag,
  holidayMessageEligible = false,
  holidayMessages,
  relationships,
  traits,
  classCode,
  department,
  vendorCode,
  markStyleCode,
}) => ({
  id,
  number,
  availability: {
    available,
    bopsAvailable: bopsAvailability,
    bossAvailable: bossAvailability,
    message,
    availabilityMessage,
    lowAvailability,
    orderType,
    holidayMessages: availabilityHolidayMessages, // TODO: investigate if we still need this
    shipDays,
    shipFees,
    storeAvailability,
  },
  seller,
  marketplaceFlag,
  holidayMessageEligible,
  holidayMessages,
  relationships,
  traits,
  classCode,
  department,
  vendorCode,
  markStyleCode,
});

export default upcMapper;
